import React from "react";

class PaymentCB extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentId: this.props.match.params.paymentId,
            token: this.props.match.params.token,
            PayerID: this.props.match.params.PayerID,
        };
    }

    componentDidMount() {
        console.log(this.props);
        this.props.navigate('/account');
    }

    render() {
        return (
            <div>
                <h1>PaymentCB</h1>
                <p>paymentId: {this.state.paymentId}</p>
                <p>token: {this.state.token}</p>
                <p>PayerID: {this.state.PayerID}</p>
            </div>
        );
    }
}

export default PaymentCB;